import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        news_id: {
            news_id: null
        },
        web_con_new_images: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        pageMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getWeb_con_new_imagesRequest({dispatch,commit, state}, payload) {
            // We check if app runs with backend mode

            if (payload){
                commit("SET_NEWID", payload)
            }

            if (!config.isBackend) {
                dispatch("receiveWeb_con_new_images", null);
            } else {
                dispatch("receivingWeb_con_new_images"); // สถานะ กำลังบันทึก

                axios.get('/web_con_new_images', { params: state.news_id }).then(res => {
                    dispatch("receiveWeb_con_new_images", res.data);

                })
                    .catch((e) => {
                        console.log(e);
                        dispatch("receiveWeb_con_new_images", null);
                    })
            }
        },
        loadWeb_con_new_imageRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWeb_con_new_image", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingWeb_con_new_image");
                axios.get('/web_con_new_images/' + id).then(res => {
                    dispatch("receiveWeb_con_new_image", res.data);
                })
            }
        },
        updateWeb_con_new_imageRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingWeb_con_new_image");
            axios.put('/web_con_new_images/' + payload.news_image_id, payload).then(res => {
                dispatch("updateWeb_con_new_image", res.data);
            })
        },
        createWeb_con_new_imageRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingWeb_con_new_image");

            axios.post('/web_con_new_images', payload).then(res => {
                dispatch("receiveWeb_con_new_image", res.data);
            })
        },
        deleteWeb_con_new_imageRequest({dispatch}, payload) {

            dispatch("afterDeleteWeb_con_new_image", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingWeb_con_new_image", payload);

            axios.post('/delete_web_con_new_images', payload).then(res => {
                dispatch("deleteWeb_con_new_image", {news_image_id: payload.news_image_id, res: res});
            })


        },
        receiveWeb_con_new_images({commit}, payload) {
            commit("RECEIVED_DATAS", payload)
        },
        receivingWeb_con_new_images({commit}) {
            commit("RECEIVING_DATAS") //call matutions --> state.isReceiving = true;
        },
        receiveWeb_con_new_image({commit}, payload) {
            commit("RECEIVED_DATA", payload)
        },
        receivingWeb_con_new_image({commit}) {
            commit("RECEIVING_DATAS") //call matutions --> state.isReceiving = true;
        },
        updateWeb_con_new_image({commit}, payload) {
            commit("UPDATED_DATA", payload)
        },
        updatingWeb_con_new_image({commit}) {
            commit("UPDATING_DATA") //  call matutions --> state.isUpdating = true;
        },
        deleteWeb_con_new_image({commit}, payload) {
            commit("DELETED_DATA", payload)
        },
        deletingWeb_con_new_image({commit}, payload) {
            commit("DELETING_DATA", payload)
        },
        afterDeleteWeb_con_new_image({commit}, payload) {
            commit("AFFTER_DELETED_DATA", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_DATAS(state, payload) {
            state.web_con_new_images = payload;
            state.isReceiving = false;

        },
        RECEIVING_DATAS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_DATA(state, payload) {


            if (payload.news_image_id == undefined) {
                let error = !payload.e.errorInfo==true?payload.message:payload.e.errorInfo.toString()
                let pageMessage = 'พบข้อผิดพลาด :' + error
                state = Object.assign(state, {
                    isReceiving: false,
                    pageMessage: (state.pageMessage == pageMessage ? pageMessage + ' ' : pageMessage),

                });
            } else {
                let pageMessage = 'บันทึกสำเร็จ! รายการ ' + payload.news_image_id + ' ถูกบันทึกแล้ว';

                state = Object.assign(state, {
                    web_con_new_images: [...state.web_con_new_images, payload],
                    isReceiving: false,
                    errorMessage: false,
                    pageMessage: (state.pageMessage == pageMessage ? pageMessage + ' ' : pageMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_DATA(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_DATA(state, payload) {


            let index = state.web_con_new_images.findIndex(p => p.news_image_id === payload.news_image_id);
            let pageMessage = 'บันทึกสำเร็จ! รายการ ' + payload.news_image_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                web_con_new_images: state.web_con_new_images.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                pageMessage: (state.pageMessage == pageMessage ? pageMessage + ' ' : pageMessage),
            })
        },
        UPDATING_DATA(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_DATA(state, payload) {


            if (payload.news_image_id == undefined || payload.res.data.message == 'Relation') {
                let pageMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.news_image_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,

                    pageMessage: (state.pageMessage == pageMessage ? pageMessage + ' ' : pageMessage),

                });
            } else {
                let indexToDelete = state.web_con_new_images.findIndex(p => p.news_image_id === payload.news_image_id);
                let web_con_new_images = [...state.web_con_new_images];
                web_con_new_images.splice(indexToDelete, 1);
                let pageMessage = 'บันทึกสำเร็จ! รายการ ' + payload.news_image_id + ' ถูกลบแล้ว';

                state = Object.assign(state, {
                    web_con_new_images: [...web_con_new_images],
                    isDeleting: false,
                    idToDelete: null,
                    pageMessage: (state.pageMessage == pageMessage ? pageMessage + ' ' : pageMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_DATA(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.news_image_id;
        },
        AFFTER_DELETED_DATA(state) {
            state.errorMessage = false;

        },
        SET_NEWID(state,payload) {
            state.news_id.news_id = payload.news_id;
            state.errorMessage=false;
            state.pageMessage='';

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
